import React from 'react';
import { LogoInfinityCursor } from './LogoInfinityCursor';

interface SwastikLogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const SingleSwastik: React.FC<{ size: string; strokeW: string; dotR: number }> = ({ size, strokeW, dotR }) => (
  <svg viewBox="0 0 140 100" className={size} fill="none" stroke="currentColor" strokeWidth={strokeW} strokeLinecap="round" strokeLinejoin="round">
    {/* Main cross */}
    <path d="M 70,15 L 70,85 M 35,50 L 105,50" />
    {/* Authentic right angle / slight curve extensions */}
    <path d="M 70,15 L 100,15 Q 105,15 105,20" />
    <path d="M 105,50 L 105,80 Q 105,85 100,85" />
    <path d="M 70,85 L 40,85 Q 35,85 35,80" />
    <path d="M 35,50 L 35,20 Q 35,15 40,15" />
    
    {/* Inner dots */}
    <circle cx="52" cy="32" r={dotR} fill="currentColor" stroke="none" />
    <circle cx="88" cy="32" r={dotR} fill="currentColor" stroke="none" />
    <circle cx="52" cy="68" r={dotR} fill="currentColor" stroke="none" />
    <circle cx="88" cy="68" r={dotR} fill="currentColor" stroke="none" />
  </svg>
);

export const SwastikLogo: React.FC<SwastikLogoProps> = ({ className = '', size = 'md' }) => {
  const containerSize = size === 'sm' ? 'px-2 h-8' : size === 'lg' ? 'px-4 h-12 sm:h-14' : 'px-3 h-10 sm:h-12';
  const swastikSize = size === 'sm' ? 'w-5 h-4' : size === 'lg' ? 'w-8 h-6 sm:w-10 sm:h-8' : 'w-6 h-5 sm:w-7 sm:h-6';
  const strokeW = size === 'sm' ? 8 : size === 'lg' ? 9 : 8.5;
  const dotR = size === 'lg' ? 4.5 : 4;
  const infinityWidth = size === 'sm' ? 32 : size === 'lg' ? 48 : 38;
  const infinityHeight = size === 'sm' ? 14 : size === 'lg' ? 20 : 16;

  return (
    <div className={`${containerSize} rounded-xl bg-red-50 flex items-center justify-center gap-1.5 sm:gap-2 shadow-xs border border-red-200 shrink-0 ${className}`}>
      <div className="flex items-center gap-1.5 sm:gap-2 text-red-600">
        <SingleSwastik size={swastikSize} strokeW={strokeW.toString()} dotR={dotR} />
        <LogoInfinityCursor width={infinityWidth} height={infinityHeight} variant="cosmic-red" />
        <SingleSwastik size={swastikSize} strokeW={strokeW.toString()} dotR={dotR} />
      </div>
    </div>
  );
};

